import type { ReactNode } from 'react';
import { t } from '@lingui/core/macro';
import { CircleAlert } from 'lucide-react';
import { cn } from '@/lib/utils';
import { Alert, AlertDescription, AlertTitle } from './ui/alert';

/** The red card every camera and upload error is shown in, over the dark capture screens. */
export function CameraErrorAlert({ className, children }: { className?: string; children: ReactNode }) {
  return (
    <Alert
      variant="destructive"
      className={cn(
        // The destructive variant colours the description through a child selector; override it the same way.
        'max-w-md border-red-500 bg-red-500 text-left text-base text-white *:data-[slot=alert-description]:text-white',
        className
      )}
    >
      <CircleAlert />
      <AlertTitle>{t`Error`}</AlertTitle>
      <AlertDescription className="text-base">{children}</AlertDescription>
    </Alert>
  );
}
